// ============= Imports =============
import { FC, Suspense } from 'react';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { HeaderLayout } from './components/layout/headerLayout/HeaderLayout';
import { LoadingSpinner, ThemeProvider } from '@tw/tw-component-library';
import { BodyLayout } from './components/layout/bodyLayout/BodyLayout';
import { WorkflowProvider } from './contexts/WorkflowContext';
import { UseAuth } from './contexts/AuthContext';

// ============= Component =============
const App: FC = () => {
  const { isAuthenticated, activeAccount, login, logout } = UseAuth();

  return (
    <ThemeProvider>
      <HeaderLayout
        isAuthenticated={isAuthenticated}
        activeAccount={activeAccount}
        login={login}
        logout={logout}
      >
        {isAuthenticated && (
          <AuthenticatedTemplate>
            <Suspense fallback={<LoadingSpinner />}>
              <WorkflowProvider>
                  <BodyLayout />
              </WorkflowProvider>
            </Suspense>
          </AuthenticatedTemplate>
        )}
      </HeaderLayout>
    </ThemeProvider>
  );
};

export default App;
